@use "@/styles/themes/themes";
@use "@/styles/variables/transitions" as *;
@use "sass:color";

.primaryButton {
  @include themes.theme() {
    background-color: themes.themeValue(primary);
    border: 1px solid color.adjust(themes.themeValue(primary), $lightness: -15%);
    color: themes.themeValue(generic-text-alt);
    transition: $default-transition;
  }

  &:hover {
    @include themes.theme() {
      background-color: themes.themeValue(primary-400);
      border-color: color.adjust(
        themes.themeValue(primary-400),
        $lightness: -5%
      );
    }
  }

  &:active {
    @include themes.theme() {
      background-color: themes.themeValue(primary-500);
      border-color: color.adjust(
        themes.themeValue(primary-500),
        $lightness: -15%
      );
    }
  }

  border-radius: 4px;
}
